import React from "react";

import Section from "../../../HOC/Section";
import aboutImage from "../../../assets/img/about.jpg";
import ImageHover from "../../ImageHover";

const about = () => {
  return (
    <Section id="about">
      <div className="container pt-2 pb-5">
        <div className="section-header pt-5 pb-3 text-center">
          <h3 className="section-title">
            <span>品牌优势</span>
          </h3>
          <h6 className="section-subtitle mr-auto ml-auto">
            UBC公司是日本东晟株式会社IKO集团旗下的国际知名综合性轴承制造商和服务商，具有先进的轴承制造工艺和管理技术。UBC在全球近30个国家和地区建立了销售网络，为广大客户提供了值得信赖的
            高品质产品。在IKO集团的管理下，UBC中国目前已经成为服务全球客户的研发、制造和销售的重要基地。UBC产品服务范围涵盖变速箱、减速机、机器
            人、压缩机、泵、机床、工程机械、农业机械、
            矿山、煤机、冶金、造纸、火电、风电等多个行业。
          </h6>

          <h6 className="section-subtitle mr-auto ml-auto">
            更重要的是，UBC产品具有合理的性价比，客户可以以合理的价
            格，完美地体验到世界一流品牌的产品质量，以及更加完美、更
            加贴心的服务。同时，UBC通过不懈的追求，建立了一整套快速反
            应的信息沟通系统，确保将UBC产品在更短的时间、更少的环节送达给客户。
          </h6>

          <h6 className="section-subtitle mr-auto ml-auto">
            UBC通过了ISO 9001:2015及IATF 16949:2016质量体系认证。UBC
            通过其完整的质量控制和保障体系和持续改进的机制，采用TQC全
            面质量管理的工作模式，全面的质量检测手段、检测仪器与检测
            标准，配合定期的培训，充分地确保了UBC整体产品质量在行业中
            居领先水平。
          </h6>

          <h6 className="section-subtitle mr-auto ml-auto">
            UBC 拥有一支强大的给客户提供售前和售后服务的 工程师团
            队，真正的协助客户解决他们的机械设备在 工作过程中遇到的各
            种难题，帮助客户在提升生产效 率的同时降低生产成本。2020年 UBC
            将在中国上线 新开发产品，AXPB 直线导轨、凸轮滚针轴承、 交叉滚
            子轴承的创新产品，希望新老客户能体验到新产品与 传
            统产品对比的优秀之处，从而获得更大的效益!
          </h6>
        </div>

        <ImageHover imgUrl={aboutImage} />

        {/* <div className="section-content">
          <div className="row">
            <div className="col-md-12 col-lg-6 mb-3">
              <div className="aboutImage">
                <img src={aboutImage} alt="about company" />
              </div>
            </div>
            <div className="col-md-12 col-lg-6">
              <h3 className="about-title">About us</h3>
              <div className="about-description">
                <p>
                  Curabitur aliquet quam id dui posuere blandit. Donec
                  sollicitudin molestie malesuada Pellentesque ipsum id orci
                  porta dapibus. Vivamus suscipit tortor eget felis porttitor
                  volutpat.
                </p>
                <p>
                  Neque porro quisquam est, qui dolorem ipsum quia dolor , sed
                  quia non numquam eius modi tempora incidunt ut labore et
                  dolore magnam aliquam quaerat voluptatem. Nisi ut aliquid ex
                  ea commodi consequatur?
                </p>
                <p>
                  Quis autem vel eum iure reprehenderit qui in ea voluptate
                  velit esse quam nihil molestiae consequatur, vel illum qui
                  dolorem eum fugiat quo voluptas nulla pariatur
                </p>
                <button className="btn btn-primary rounded-0">Read More</button>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </Section>
  );
};

export default about;
